if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
          evt.preventDefault();
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

          this.handleErrorMessage();

          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);
          let extraItemIndex = 1;

          const upsellBox = document.querySelector('upsell-add-on');
          if (upsellBox) {
            const selectedUpsells = upsellBox.getSelectedProducts();
            
            if (selectedUpsells && selectedUpsells.length > 0) {
              selectedUpsells.forEach((product) => {
                formData.append(`items[${extraItemIndex}][id]`, product.variantId);
                formData.append(`items[${extraItemIndex}][quantity]`, 1);
                extraItemIndex++;
              });
            }
          }

          // --- CUSTOM ADD-ON LOGIC START ---
        const mainVariantId = formData.get('id'); // Get the main product's variant ID
        const mainQty = formData.get('quantity') || 1;
          const giftBox = document.getElementById("giftBoxCheckbox");
          const clothBox = document.getElementById("cleaningClothCheckbox");

          if (giftBox && giftBox.checked) {
             const giftVariantId = giftBox.getAttribute('data-variant-id');
             if (giftVariantId) {
               formData.append(`items[${extraItemIndex}][id]`, giftVariantId);
               formData.append(`items[${extraItemIndex}][quantity]`, mainQty);
               formData.append(`items[${extraItemIndex}][properties][_linked_variant]`, mainVariantId);
               extraItemIndex++;
             }
          }

          if (clothBox && clothBox.checked) {
             const clothVariantId = clothBox.getAttribute('data-variant-id');
             if (clothVariantId) {
               formData.append(`items[${extraItemIndex}][id]`, clothVariantId);
               formData.append(`items[${extraItemIndex}][quantity]`, mainQty);
               formData.append(`items[${extraItemIndex}][properties][_linked_variant]`, mainVariantId);
               extraItemIndex++;
             }
          }
          // --- CUSTOM ADD-ON LOGIC END ---

          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }

          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error) {
                // --- RESET CHECKBOXES AFTER SUCCESSFUL ADD ---
                if (giftBox) giftBox.checked = false;
                if (clothBox) clothBox.checked = false;
                const noteField = document.getElementById("giftNoteField");
                if (noteField) {
                  const noteTextarea = noteField.querySelector("textarea");
                  if (noteTextarea) {
                    noteTextarea.value = "";
                    noteTextarea.disabled = true;
                  }
                  noteField.style.display = "none";
                }
                // ---------------------------------------------

                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              }
              
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              const quickViewModal = document.getElementById('product-modal');
              
              if (quickViewModal) {
                quickViewModal.classList.remove('active');
                document.body.classList.remove('quickview-open');
              }

              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
            });
      }


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
